<div class="relative h-12 w-9">
    <bizz-icon class="absolute ml-auto block h-12 w-12 md:ml-0" iconName="file" [ngClass]="clsName" />
    <span class="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform text-sm font-bold text-white">{{content}}</span>
</div>
